import { Alert } from "@mui/material";

export const AlertBox = ({
  message,
  type,
}: {
  message: string;
  type: "warning" | "success" | "info" | "error";
}) => {
  return (
    <Alert sx={{ width: "100%", textAlign: "center", justifyContent: "center" }} severity={type}>
      {message}
    </Alert>
  );
};
